import { useEffect } from 'react';
import { useStoreSettings } from '../hooks/useStoreSettings';

/**
 * Syncs the browser tab title and favicon with values from store_settings:
 *   - <title> ← store_settings.store_name
 *   - favicon ← store_settings.header_content.logo.url
 *
 * Renders nothing — pure side effects.
 */
export const DocumentMeta = () => {
  const { settings } = useStoreSettings();

  useEffect(() => {
    if (!settings) return;

    const storeName = settings.store_name?.trim();
    if (storeName) document.title = storeName;

    const logoUrl = (settings.header_content as any)?.logo?.url;
    if (!logoUrl) return;

    // Reuse existing <link rel="icon"> if present, otherwise create one.
    // The default link in index.html declares type="image/svg+xml"; remove
    // that attribute since the tenant logo is typically PNG/JPG and the
    // browser will reject the wrong MIME.
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.removeAttribute('type');
    link.href = logoUrl;

    // Apple touch icon, since browsers fall back to it on iOS / when bookmarked.
    let apple = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
    if (!apple) {
      apple = document.createElement('link');
      apple.rel = 'apple-touch-icon';
      document.head.appendChild(apple);
    }
    apple.href = logoUrl;
  }, [settings]);

  return null;
};

export default DocumentMeta;
